 // Whole Component Tejashwini
import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Divider,
  IconButton,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Box,

} from "@mui/material";
import ListAltIcon from "@mui/icons-material/ListAlt";
import CloseIcon from "@mui/icons-material/Close";

export default function RefundedProductsDialog({ open, handleClose, rows }) {
  return (
    <Dialog
    open={open}
    onClose={handleClose}
    maxWidth="sm"
    fullWidth
    sx={{
      "& .MuiDialog-paper": {
        width: "100%",
        maxWidth: "800px", // realistic maximum
        margin: "auto",
      },
    }}
    BackdropProps={{ style: { backgroundColor: "rgba(0, 0, 0, 0.1)" } }}
  >
  
    <Box
      sx={{
        backgroundColor: "#ffffff",
       
        borderRadius: "12px",
        
        boxShadow: "0px 4px 10px rgba(0,0,0,0.1)",
        
      }}
    >
      {/* Dialog Title */}
      <DialogTitle
  sx={{
    display: "flex",
    // alignItems: "center",
    justifyContent: "space-between",
    padding: "-0px -0px",
    backgroundColor: "#ffffff",
    maxHeight: "300px",
    overflowY: rows.length > 5 ? "auto" : "unset",
    color: "#0A64A2",
    height:'3em',
  }}
>
<Box sx={{ display: "flex", alignItems: "center", }}>
  <ListAltIcon sx={{ ml: 1.4, marginRight: "15px", marginTop:'1em'}} />
  <span
    style={{
      fontWeight: "bold",
      fontSize: "20px",
      position: "relative",
      right: "3%",
       marginTop:'1.2em'
    }}

  >
    Refunded Products List
  </span>
</Box>

  <IconButton onClick={handleClose}  sx={{
      color: "#A9A9A9",
      position: "absolute",
      right: 0.2, // <-- little to the left
      top: 1,
      
    }}>
    <CloseIcon />
  </IconButton>
</DialogTitle>

  
      {/* Divider (Full Width) */}
      <Divider sx={{ width: "97%",marginLeft: "0.8em", backgroundColor: "#0A64A2" ,left:'8em',}} />
  
      {/* Dialog Content */}
      <DialogContent
  style={{
    color: "#0A64A2",
    padding: "0px 11px",  
    alignItems: "center",
  }}
>    
 
  {rows.length > 0 ? (
    <Table size="small">
      <TableHead>
        <TableRow>
          <TableCell sx={{ color: "#0A64A2", textAlign: "center" }}>S.No</TableCell>
          <TableCell sx={{ color: "#0A64A2", textAlign: "left" ,minWidth: "150px",}}>Product Name</TableCell>
          <TableCell sx={{ color: "#0A64A2", textAlign: "left",pl: "5px", pr: "5px"}}>Quantity</TableCell>
          <TableCell sx={{ color: "#0A64A2", textAlign: "center", pl: "5px", pr: "15px"}}>Amount</TableCell>
          <TableCell sx={{ color: "#0A64A2", textAlign: "center", pr: "15px" }}>Date</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {rows.map((p, index) => (
          <TableRow key={p.product_id}>
            <TableCell sx={{ textAlign: "center", whiteSpace: "nowrap" }}>{index + 1}</TableCell>
            <TableCell
  sx={{
    // color: "#0A64A2",
    textAlign: "left",
    width: "150px",           // fixed width
    overflow: "hidden",
    textOverflow: "ellipsis", // adds "..." for long text
    whiteSpace: "nowrap"
  }}
  title={p.product_name} // shows full name on hover
>
  {p.product_name}
</TableCell>


            <TableCell
              sx={{ textAlign: "left", whiteSpace: "nowrap",pl: "5px", pr: "5px"  }}
              title={String(p.quantity)}
            >
              {p.quantity}
            </TableCell>
            <TableCell
              sx={{ textAlign: "center", whiteSpace: "nowrap",pl: "5px", pr: "20px" }}
              title={String(p.price)}
            >
              {p.price}
            </TableCell>  
            <TableCell
              sx={{ textAlign: "center", whiteSpace: "nowrap" , pl: "5px"}}
              title={new Date(p.created_timestamp).toLocaleDateString()}
            >
              {new Date(p.created_timestamp).toLocaleDateString()}
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  ) : (
    <Box sx={{ color: "Black", textAlign: "center", padding: "15px 50px", fontSize: "0.9em" }}>
      No Refund Product List Available.
    </Box>
  )}
</DialogContent>

<Box sx={{ height: "20px" }} />
</Box>
  </Dialog>
  
  );
}